import { Debounce } from "./lib/debounce.js";

export class RenderUtils {
  #global;

  /**
   * Creates an instance of RenderUtils.
  * @constructor
  * @param {Object} param
  * @param {Window} param.global
  */
  constructor({ global }) {
    this.#global = global;
  }

  /** @type {Debounce} */
  get debounce() {
    return new Debounce({ global: this.#global });
  }
}

/** @type {RenderUtils} */
export const renderUtils = new RenderUtils({
  global: window,
});
